import { useTheme } from '@mui/material/styles';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import ConfirmDeletion from '../../components/confirm-deletion';
import LoadingIndicator from '../../components/loading-indicator';
import {
  deleteChannelWithSecurePayment,
  getChannelsWithSecurePayment,
  saveChannelWithSecurePayment,
} from './api-services';
import { AppContent, ContentRow } from 'styled/components';
import ModifyInstance from './modify-instance';
import useDatatable from '../../hooks/use-datatable';
import TableHeader from '../../components/table-header';

function ChannelsWithSecurePayment() {
  const theme = useTheme();

  const validateForm = (instance, _instancesList) => {
    const existingInstance = _instancesList.find(
      _instance => _instance.contactId === instance.contactId && _instance.id !== instance.id
    );
    return existingInstance
      ? 'This contact is already in the list.'
      : null;
  };

  const filterInstances = (instancesList, filter) => {
    return instancesList.filter(
      _instance => (_instance.contactName || '').toLowerCase().includes(filter.toLowerCase()),
    );
  };

  const {
    ready,
    rangeEnd,
    rangeStart,
    instancesList,
    selectedInstance,
    selectedInstanceError,
    showEditForm,
    showDeleteConfirm,
    filter,

    // Functions
    filterChange,
    saveInstance,
    deleteInstance,

    handleAddButtonClicked,
    handleCancelEditButtonClicked,
    handleDeleteButtonClicked,
    handleCancelDeleteButtonClicked,
  } = useDatatable(
    getChannelsWithSecurePayment,
    filterInstances,
    saveChannelWithSecurePayment,
    validateForm,
    deleteChannelWithSecurePayment,
  );

  if (!ready) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <AppContent>
        <TableHeader
          title="Channels with secure payment"
          showAddButton
          handleAddButtonClicked={handleAddButtonClicked}
          filter={filter}
          filterChange={filterChange}
          firstItemIndex={rangeStart}
          lastItemIndex={rangeEnd}
          totalItems={instancesList.length}
        />
        <ContentRow>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Contact</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {instancesList.length > 0 && instancesList.map((_instance) => (
                  <TableRow
                    key={_instance.id}
                    sx={{
                      'td': { paddingTop: 1, paddingBottom: 1 },
                      '&:last-child td, &:last-child th': { border: 0 }
                    }}
                  >
                    <TableCell>{_instance.contactName || `Contact #${_instance.contactId}`}</TableCell>
                    <TableCell sx={{ width: 40 }} align="right">
                      <IconButton onClick={() => handleDeleteButtonClicked(_instance)}><DeleteIcon
                        sx={{ color: theme.palette.error.light }} /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {instancesList.length === 0 && (
                  <TableRow
                    sx={{
                      'td': { paddingTop: 1, paddingBottom: 1 },
                      '&:last-child td, &:last-child th': { border: 0 }
                    }}
                  >
                    <TableCell align="center" colSpan={2}>
                      <Typography>There are no Channels yet. Add the first one by clicking the "Add new"
                        button</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </ContentRow>
      </AppContent>
      {showDeleteConfirm && (
        <ConfirmDeletion
          handleClose={() => handleCancelDeleteButtonClicked(false)}
          handleConfirm={() => deleteInstance(selectedInstance)}
          deleteInstanceMsg={`the Channel: ${selectedInstance.contactName}`}
        />
      )}
      {showEditForm && (
        <ModifyInstance
          handleClose={() => handleCancelEditButtonClicked(false)}
          handleConfirm={saveInstance}
          error={selectedInstanceError}
          instance={selectedInstance}
        />
      )}
    </>
  );
}

export default ChannelsWithSecurePayment;
